import React, { useState, useEffect } from "react";
import { Button, Select, Tooltip } from "antd";
import ParliamentaryMap from '../ParliamentaryMap'
import ExpandIcon from "../../../../assets/svg/expandIcon.svg";
import AssemblyDataTable from "./AssemblyDataTable";

import GraphModal from "../../GraphModal";
import NoDataIcon from "../../../../assets/svg/no-data.svg";
import sampleVillageData from "../../VillageInfo/sampleVillageData.json";

import { getGraphData } from "../../utils/getFromattedValue";
import { renderCharts } from "../../utils/renderCharts";
import { useTranslation } from "react-i18next";
import { FullscreenOutlined, CloseOutlined } from "@ant-design/icons";


const AssemblyData = ({
  constituencyData,
  loading,
  summaryData,
  polygonData,
  constituencyDataList,
  center,
  setSelectedMarker = () => {},
  villageFetchedData,
  prevVillageFetchedData,
  isDataAvailable,
  selectedMarker,
  isLoading,
  electionYears,
  setSelectedYear,
  constituencyId,
  year,
  setYear,
  previousYear,
  setPreviousYear,
  constituencyLoading
}) => {

  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("age");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  
  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const graphData = getGraphData(
    selectedOption,
    sampleVillageData,
    villageFetchedData
  );

  return (
  <>
    <div className='constituency-data mt-5 flex flex-col'>
      <h4 className='flex justify-center mb-2'>{t("Assembly Data")}</h4>

      <div className='w-full h-full flex flex-row gap-4 cdm-assembly-data-responsive'>
        <div
          className={`w-[60%] relative ${
            isFullScreen
              ? "fixed inset-0 bg-black bg-opacity-90 z-40 transition-opacity duration-500 ease-in-out"
              : ""
          } cdm-village-items-responsive`}
          style={{ height: "792px" }}
        >
          <div className='village-data-tooltip absolute top-0 right-0 z-1'>
            <div className='village-data-tooltip' style={{ margin: 0 }}>
              <h3>{t("Assembly Type")} </h3>
              <div className='flex justify-between village-type'>
                <p
                  style={{
                    background: selectedMarker?.winnerParty?.colorCode,
                    marginRight: "5px"
                  }}
                >
                  {selectedMarker?.winnerParty?.name}
                </p>
                <p
                  style={{
                    background: selectedMarker?.runnerUpParty?.colorCode,
                    marginRight: "5px"
                  }}
                >
                  {selectedMarker?.runnerUpParty?.name}
                </p>
                <p
                  style={{
                    background: selectedMarker?.firstRunnerUpParty?.colorCode
                  }}
                >
                  {selectedMarker?.firstRunnerUpParty?.name}
                </p>
              </div>
            </div>
          </div>

          <div className='village-data-tooltip absolute top-0 left-0 z-1 hideMapLeftTop'>
            <Tooltip title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}>
              <Button
                icon={
                  isFullScreen ? <CloseOutlined /> : <FullscreenOutlined />
                }
                onClick={toggleFullScreen}
                shape='circle'
                size='large'
                className='absolute top-5 left-5 z-50'
                disabled={
                  !constituencyDataList || constituencyDataList.length === 0
                }
              />
            </Tooltip>
          </div>

          <ParliamentaryMap
            polygonData={constituencyData}
            center={center}
            setSelectedMarker={setSelectedMarker}
            selectedMarker={selectedMarker}
            isDataAvailable={isDataAvailable}
            villageFetchedData={villageFetchedData?.electoralData}
            prevVillageFetchedData={prevVillageFetchedData}
            isFullScreen={isFullScreen}
            setIsFullScreen={setIsFullScreen}
            onExitFullScreen={() => {
              setIsFullScreen(false);
            }}
            electionYears={electionYears}
            setSelectedYear={setSelectedYear}
            constituencyId={constituencyId}
            year={year}
            setYear={setYear}
            previousYear={previousYear}
            setPreviousYear={setPreviousYear}
          />
        </div>

        <div className='w-[40%] flex flex-col village-data cdm-village-items-responsive'>
          <AssemblyDataTable
            isDataAvailable={isDataAvailable}
            data={villageFetchedData?.electoralData}
            selectedMarker={selectedMarker}
            villageLoading={isLoading}
            constituencyLoading={constituencyLoading}
          />

          <div className='col-span-12 sm:col-span-5 mt-4 constituenct-data-table'>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <h1 className='ml-6'>{t("Assembly Electoral Data")}</h1>
              <div className='flex-grow' />
              <div className='ml-auto pr-1'>
                <Select
                  className='mr-2'
                  placeholder='Select'
                  value={selectedOption}
                  onChange={handleSelectChange}
                  disabled={!isDataAvailable}
                >
                  <Select.Option value='age'>{t("age")}</Select.Option>
                  <Select.Option value='gender'>{t("gender")}</Select.Option>
                  <Select.Option value='ageGender'>
                    {t("ageVsGender")}
                  </Select.Option>
                </Select>
              </div>

              <img
                className='cursor-pointer'
                src={ExpandIcon}
                alt=''
                onClick={openModal}
              />
            </div>

            {renderCharts(
              selectedOption,
              isDataAvailable,
              graphData,
              isLoading
            )}
          </div>
        </div>
      </div>
    </div>

    <GraphModal
      isDataAvailable={isDataAvailable}
      isModalVisible={isModalVisible}
      closeModal={closeModal}
      graphData={graphData}
      selectedOption={selectedOption}
    />
  </>
);

};

export default AssemblyData;
